"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authDefaultAccessDeniedMessageTimeout = exports.authAccessDeniedMessageTimeout = exports.authDefaultAccessDeniedMessage = exports.authAccessDeniedMessage = exports.authDefaultRedirectAfterSignInRoute = exports.authRedirectAfterSignInRoute = exports.authSignOutRoute = exports.authSignInRoute = exports.authResetSubscribers = exports.authReset = exports.authSignout = exports.authClearRefreshtoken = exports.authClearAccesstoken = exports.authRefreshtoken = exports.authAccesstoken = exports.resetRefreshGrant = exports.initRefreshGrant = exports.resetAuthorizeGrant = exports.initAuthorizeGrant = exports.authBusy = exports.authInitialized = void 0;
const actiontypes_1 = require("./actiontypes");
// --- COMMONS ------------------------------
function authInitialized(initialized) {
    return {
        type: actiontypes_1.AUTH_INITIALIZED,
        initialized
    };
}
exports.authInitialized = authInitialized;
function authBusy(busy) {
    return {
        type: actiontypes_1.AUTH_BUSY,
        busy
    };
}
exports.authBusy = authBusy;
function initAuthorizeGrant(state, codeVerifier, codeChallenge) {
    return {
        type: actiontypes_1.AUTH_INIT_AUTHORIZE_GRANT,
        state,
        codeVerifier,
        codeChallenge,
    };
}
exports.initAuthorizeGrant = initAuthorizeGrant;
function resetAuthorizeGrant() {
    return {
        type: actiontypes_1.AUTH_RESET_AUTHORIZE_GRANT,
    };
}
exports.resetAuthorizeGrant = resetAuthorizeGrant;
function initRefreshGrant(state) {
    return {
        type: actiontypes_1.AUTH_INIT_REFRESH_GRANT,
        state,
    };
}
exports.initRefreshGrant = initRefreshGrant;
function resetRefreshGrant() {
    return {
        type: actiontypes_1.AUTH_RESET_REFRESH_GRANT,
    };
}
exports.resetRefreshGrant = resetRefreshGrant;
function authAccesstoken(token, decodedToken) {
    return {
        type: actiontypes_1.AUTH_ACCESSTOKEN,
        token,
        decodedToken,
    };
}
exports.authAccesstoken = authAccesstoken;
function authRefreshtoken(token) {
    return {
        type: actiontypes_1.AUTH_REFRESHTOKEN,
        token
    };
}
exports.authIdToken = authIdToken;
function authIdToken(token) {
    return {
        type: actiontypes_1.AUTH_IDTOKEN,
        token
    };
}
exports.authRefreshtoken = authRefreshtoken;
function authClearAccesstoken() {
    return {
        type: actiontypes_1.AUTH_CLEAR_ACCESSTOKEN,
    };
}
exports.authClearAccesstoken = authClearAccesstoken;
function authClearRefreshtoken() {
    return {
        type: actiontypes_1.AUTH_CLEAR_REFRESHTOKEN,
    };
}
exports.authClearRefreshtoken = authClearRefreshtoken;
function authSignout() {
    return {
        type: actiontypes_1.AUTH_SIGNOUT
    };
}
exports.authSignout = authSignout;
function authReset() {
    return {
        type: actiontypes_1.AUTH_RESET
    };
}
exports.authReset = authReset;
function authResetSubscribers(subscribers) {
    return {
        type: actiontypes_1.AUTH_RESET_SUBSCRIBERS,
        subscribers,
    };
}
exports.authResetSubscribers = authResetSubscribers;
function authSignInRoute(route) {
    return {
        type: actiontypes_1.AUTH_SIGN_IN_ROUTE,
        route,
    };
}
exports.authSignInRoute = authSignInRoute;
function authSignOutRoute(route) {
    return {
        type: actiontypes_1.AUTH_SIGN_OUT_ROUTE,
        route,
    };
}
exports.authSignOutRoute = authSignOutRoute;
function authRedirectAfterSignInRoute(route) {
    return {
        type: actiontypes_1.AUTH_REDIRECT_AFTER_SIGN_IN_ROUTE,
        route: route || undefined,
    };
}
exports.authRedirectAfterSignInRoute = authRedirectAfterSignInRoute;
function authDefaultRedirectAfterSignInRoute(route) {
    return {
        type: actiontypes_1.AUTH_DEFAULT_REDIRECT_AFTER_SIGN_IN_ROUTE,
        route,
    };
}
exports.authDefaultRedirectAfterSignInRoute = authDefaultRedirectAfterSignInRoute;
function authAccessDeniedMessage(msg) {
    return {
        type: actiontypes_1.AUTH_ACCESS_DENIED_MESSAGE,
        msg,
    };
}
exports.authAccessDeniedMessage = authAccessDeniedMessage;
function authDefaultAccessDeniedMessage(msg) {
    return {
        type: actiontypes_1.AUTH_DEFAULT_ACCESS_DENIED_MESSAGE,
        msg,
    };
}
exports.authDefaultAccessDeniedMessage = authDefaultAccessDeniedMessage;
function authAccessDeniedMessageTimeout(timeout) {
    return {
        type: actiontypes_1.AUTH_ACCESS_DENIED_MESSAGE_TIMEOUT,
        timeout,
    };
}
exports.authAccessDeniedMessageTimeout = authAccessDeniedMessageTimeout;
function authDefaultAccessDeniedMessageTimeout(timeout) {
    return {
        type: actiontypes_1.AUTH_DEFAULT_ACCESS_DENIED_MESSAGE_TIMEOUT,
        timeout,
    };
}
exports.authDefaultAccessDeniedMessageTimeout = authDefaultAccessDeniedMessageTimeout;
